import { Div } from '../utils/styled';
import * as React from 'react';

export const SpinnerCircle = () => {
    return (
        <Div
            sx={{
                '@keyframes preloaderAnimation': {
                    '0%': {
                        transform: 'rotate(0deg)',
                    },
                    '100%': {
                        transform: 'rotate(360deg)',
                    },
                },
                animationDuration: '1.5s',
                animationIterationCount: 'infinite',
                animationName: 'preloaderAnimation',
                animationTimingFunction: 'linear',
                width: '80px',
                height: '80px',
            }}
        >
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M40 4.25C20.2558 4.25 4.25 20.2558 4.25 40C4.25 59.7442 20.2558 75.75 40 75.75C40.4142 75.75 40.75 76.0858 40.75 76.5C40.75 76.9142 40.4142 77.25 40 77.25C19.4274 77.25 2.75 60.5726 2.75 40C2.75 19.4274 19.4274 2.75 40 2.75C60.06 2.75 76.4162 18.6063 77.2191 38.4697C77.2359 38.8836 76.914 39.2326 76.5001 39.2494C76.0861 39.2661 75.7371 38.9441 75.7204 38.5304C74.9498 19.4679 59.2519 4.25 40 4.25Z"
                    stroke="url(#paint0_linear_1220_119607)"
                    strokeWidth="1.5"
                />
                <defs>
                    <linearGradient id="paint0_linear_1220_119607" x1="40" y1="40" x2="40" y2="78" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#7633FF" />
                        <stop offset="1" stopColor="white" />
                    </linearGradient>
                </defs>
            </svg>
        </Div>
    );
};
